export const onDiagnosticProgressReset = (_, get) => {
  get().resetDiagnosticProcess?.(); // quizzes slice
  get().resetDiagnosticProgress?.(); // user store
};
